import React from "react";
import "./LifeAtModal.scss";

interface LifeAtModalContentRowProps {
    children: JSX.Element | JSX.Element[];
}
export default function LifeAtModalContentRow(props: LifeAtModalContentRowProps) {
    return <span className={"modal-content-row"}>{props.children}</span>;
}
